import { apiRequest } from "util/services";
import store from "redux/store";
import { SET_USER } from "redux/user/actions";
import {
  mountEmbeddedCheckout,
  redirectToStripeCheckout,
} from "util/stripeCheckout";

function checkoutUrls(returnPath, queryKey) {
  const origin = window.location.origin;
  const path = returnPath.startsWith("/") ? returnPath : `/${returnPath}`;
  return {
    success_url: `${origin}${path}?${queryKey}=success`,
    cancel_url: `${origin}${path}?${queryKey}=cancelled`,
  };
}

export async function refreshUserSubscription(userId) {
  if (!userId) return null;
  const subscription = await apiRequest(
    "subscriptions/all",
    "POST",
    { user_id: userId },
    true,
  );
  if (subscription?.[0]) {
    store.dispatch({ type: SET_USER, payload: subscription[0] });
  }
  return subscription;
}

export async function createSurveyTierCheckoutSession({
  tier,
  returnPath = "/console/surveys",
  checkoutUi = "embedded",
  billingInterval = "annual",
}) {
  const urls = checkoutUrls(returnPath, "survey_purchase");
  return apiRequest(
    "subscriptions/sonic-survey/stripe/checkout",
    "POST",
    {
      tier,
      billing_interval: billingInterval,
      checkout_ui: checkoutUi,
      ...urls,
    },
    true,
  );
}

export async function changeSurveyTier({
  tier,
  billingInterval = "annual",
}) {
  return apiRequest(
    "subscriptions/sonic-survey/stripe/change-tier",
    "POST",
    {
      tier,
      billing_interval: billingInterval,
    },
    true,
  );
}

export async function mountSurveyStripeCheckout(container, sessionPayload) {
  const {
    publishable_key: publishableKey,
    client_secret: clientSecret,
    checkout_url: checkoutUrl,
    session_id: sessionId,
    checkout_ui: mode,
  } = sessionPayload;

  if (mode === "embedded" && clientSecret && publishableKey && container) {
    const checkout = await mountEmbeddedCheckout({
      publishableKey,
      clientSecret,
      container,
    });
    return { mode: "embedded", checkout };
  }

  await redirectToStripeCheckout({
    publishableKey,
    sessionId,
    checkoutUrl,
  });
  return { mode: "redirect" };
}
